import { inputDark } from "@/components/shared/AdminKit";

export const STATUS_BADGE = {
  active: "bg-emerald-500/15 text-emerald-400",
  suspended: "bg-amber-500/15 text-amber-400",
  disabled: "bg-red-500/15 text-red-400",
};

export const statusLabel = (tr, s) => ({ active: tr("Actif", "Active"), suspended: tr("Suspendu", "Suspended"), disabled: tr("Désactivé", "Disabled") }[s] || s);

export function StatusBadge({ tr, status, testid }) {
  return <span data-testid={testid} className={`rounded-full px-2.5 py-0.5 text-xs font-medium ${STATUS_BADGE[status] || "bg-slate-700 text-slate-300"}`}>{statusLabel(tr, status)}</span>;
}

export function Field({ label, required, children, hint }) {
  return (
    <label className="block text-sm">
      <span className="mb-1 block text-xs font-medium text-slate-400">{label}{required && <span className="text-red-400"> *</span>}</span>
      {children}
      {hint && <span className="mt-1 block text-[11px] text-slate-500">{hint}</span>}
    </label>
  );
}

export function TextInput({ value, onChange, testid, ...rest }) {
  return <input value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} className={inputDark} {...rest} />;
}

export function ProfileFields({ tr, form, set, managers = [] }) {
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <Field label={tr("Prénom", "First name")} required><TextInput value={form.first_name} onChange={(v) => set("first_name", v)} testid="agent-first-name" /></Field>
      <Field label={tr("Nom de famille", "Last name")} required><TextInput value={form.last_name} onChange={(v) => set("last_name", v)} testid="agent-last-name" /></Field>
      <Field label={tr("E-mail professionnel (identifiant)", "Work email (login)")} required hint="@theworldpromotions.com">
        <TextInput type="email" value={form.email} onChange={(v) => set("email", v)} testid="agent-email" placeholder="prenom.nom@theworldpromotions.com" />
      </Field>
      <Field label={tr("Téléphone (indicatif international)", "Phone (international code)")}><TextInput value={form.phone} onChange={(v) => set("phone", v)} testid="agent-phone" placeholder="+243 812 345 678" /></Field>
      <Field label={tr("Poste / fonction", "Job title")} required><TextInput value={form.job_title} onChange={(v) => set("job_title", v)} testid="agent-job-title" /></Field>
      <Field label={tr("Département / service", "Department")}><TextInput value={form.department} onChange={(v) => set("department", v)} testid="agent-department" /></Field>
      <Field label={tr("Date de début", "Start date")}><TextInput type="date" value={form.start_date} onChange={(v) => set("start_date", v)} testid="agent-start-date" /></Field>
      <Field label={tr("Responsable hiérarchique", "Manager")}>
        <select value={form.manager_id || ""} onChange={(e) => set("manager_id", e.target.value)} data-testid="agent-manager" className={inputDark}>
          <option value="">{tr("Aucun", "None")}</option>
          {managers.map((m) => <option key={m.id} value={m.id}>{m.name} — {m.email}</option>)}
        </select>
      </Field>
      <div className="sm:col-span-2"><Field label={tr("Description du rôle", "Role description")}>
        <textarea value={form.role_description || ""} onChange={(e) => set("role_description", e.target.value)} rows={2} data-testid="agent-role-description" className={inputDark} />
      </Field></div>
      <div className="sm:col-span-2"><Field label={tr("Notes administratives internes", "Internal admin notes")} hint={tr("Visibles uniquement par les administrateurs.", "Visible to administrators only.")}>
        <textarea value={form.internal_notes || ""} onChange={(e) => set("internal_notes", e.target.value)} rows={2} data-testid="agent-internal-notes" className={inputDark} />
      </Field></div>
    </div>
  );
}
